import { FlowError } from '../types'
import { fireHeapEvent } from '@dtx-company/true-common/src/utils/heap'

export const logErrorToHeap = (error: FlowError): void => {
  const { type, ...errorLog } = error
  fireHeapEvent(type, {
    ...errorLog
  })
}
